import { Folder, RawFolder } from '@/core/types';

export const buildFolderEntity = (folder: RawFolder, userId?: number): Folder => {
  return {
    ...folder,
    favorite: folder.favorites.some((favorite) => favorite.user_id === userId && favorite.enabled),
    color: folder.colors.find((folderColor) => folderColor.user_id === userId)
  };
};
